import { render, staticRenderFns } from "./choseTime.vue?vue&type=template&id=146160d8&scoped=true&"
import script from "./choseTime.vue?vue&type=script&lang=js&"
export * from "./choseTime.vue?vue&type=script&lang=js&"
import style0 from "./choseTime.vue?vue&type=style&index=0&id=146160d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146160d8",
  null
  
)

export default component.exports